import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Colors } from 'src/shared/components/styles/colors';

type HelpSubCategoryCardProps = {
  title: string;
  subtitle?: string;
  articleCount: number;
  /** Adressen kortet leder till. Utan den går kortet inte att klicka på. */
  to?: string;
};

export const HelpSubCategoryCard = (props: HelpSubCategoryCardProps) => {
  const { title, subtitle, articleCount, to } = props;
  const { t } = useTranslation('help');

  // Naturlig höjd: ett kort med beskrivning blir högre utan att korten bredvid på raden får tomrum.
  return (
    <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
      {/* En riktig länk, så att kortet går att öppna i en ny flik. */}
      <CardActionArea component={Link} to={to ?? ''} disabled={!to}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box>
            <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant='body2' color='text.secondary' sx={{ whiteSpace: 'pre-line' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              alignSelf: 'stretch',
              borderRadius: 5,
              backgroundColor: Colors.AlertBgBlue,
              color: Colors.AlertTextBlue,
              textAlign: 'center',
              py: 0.75,
              fontSize: '0.8125rem',
              fontWeight: 500,
            }}
          >
            {t('articleCount', { count: articleCount })}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
